<template>
  <div class="skeleton-grid">
    <v-skeleton-loader
      v-for="n in 7"
      :key="n"
      class="custom-skeleton"
      type="image"
    ></v-skeleton-loader>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.skeleton-grid {
  display: flex;
  flex-wrap: nowrap;
  //   width: 100%;
  justify-content: space-evenly;
  gap: 20px;
}

.custom-skeleton {
  flex: 0 0 auto;
  min-width: 150px;
  max-width: 200px;
}

.custom-skeleton ::v-deep .v-skeleton-loader__button {
  margin-left: 0 !important;
  margin-right: auto !important;
}
</style>
